import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';
import { useFlySafeTranslation } from './flysafe/utils/i18n';

const menuItems = [
  { labelKey: 'flysafe-nav-home', href: '/' },
  { labelKey: 'flysafe-nav-observations', href: '/#/observations' },
  { labelKey: 'flysafe-nav-forecast', href: '/#/forecast' },
] as const;

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useFlySafeTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      <div
        style={{
          whiteSpace: 'nowrap',
          background: '#FFF',
          height: '80px',
          zoom: '100%',
          position: 'relative',
        }}
      >
        <div style={{ display: isMobile ? 'none' : 'inline' }}>
          <a href="https://www.knmi.nl/home" rel="noreferrer" target="_blank">
            <img
              alt="KNMI logo"
              height="95px"
              src="./images/knmi.svg"
              style={{ verticalAlign: 'top', marginLeft: '-80px' }}
            />
          </a>
          <a
            href="https://english.defensie.nl/organisation/air-force"
            rel="noreferrer"
            target="_blank"
          >
            <img
              alt="Air force logo"
              height="58px"
              src="./images/airforce.png"
              style={{ verticalAlign: 'top' }}
            />
          </a>
          <a href="https://ibed.uva.nl/" rel="noreferrer" target="_blank">
            <img
              alt="UvA logo"
              height="25px"
              src="./images/uva.jpg"
              style={{ verticalAlign: 'top', marginTop: '25px' }}
            />
          </a>
        </div>
        <div
          style={{
            display: 'inline-block',
            left: isMobile ? '45px' : '550px',
            width: '75%',
            fontSize: '20px',
            color: '#006496',
            position: 'absolute',
            top: '25px',
            fontWeight: 'bold',
            whiteSpace: 'pre-line',
            background: 'rgba(255, 255, 255, 0.25)',
          }}
        >
          <a href="/" style={{ color: '#006496', textDecoration: 'none' }}>
            {t('flysafe-title')}
          </a>
        </div>
        <IconButton
          aria-label="menu"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          style={{
            position: 'absolute',
            right: 16,
            top: 20,
            background: 'white',
          }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          open={Boolean(anchorEl)}
        >
          {menuItems.map(({ labelKey, href }) => (
            <MenuItem
              component="a"
              href={href}
              key={labelKey}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                setAnchorEl(null);
                // Hash-only navigations don't reload, so force it
                if (window.location.pathname + window.location.hash === href) {
                  window.location.reload();
                } else if (href.includes('#')) {
                  e.preventDefault();
                  window.location.href = href;
                  window.location.reload();
                }
              }}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              {t(labelKey)}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
};

export default Header;
